import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import RitaChakma from "../../../images/Photos/Rita Chakmaa.jpg";
import MoitriChakma from "../../../images/Photos/Moitri Chakmaa.jpg";
import SuchovanChakma from "../../../images/Photos/Sushovan Chakmaa.JPG";
import nikilMitraChakma from "../../../images/Photos/Person_image.jpg";
import UdayonChakma from "../../../images/Photos/Udayan Chakmaa.jpg";
import ShaplaBarua from "../../../images/Photos/Person_image.jpg";
import LovelyBarua from "../../../images/Photos/Person_image.jpg";
import JuktaChakma from "../../../images/Photos/Person_image.jpg";
import SabittriChakma from "../../../images/Photos/Sabittri Chakma.jpg";
import AratiChakma from "../../../images/Photos/Arati Chakmaa.jpg";
import BhubonChakma from "../../../images/Photos/Person_image.jpg";
import ArnobChakma from "../../../images/Photos/Arnob-chakma.jpg";
import MangalManiChakma from "../../../images/Photos/Mangal Mani Chakmaa.jpg";
import SamsunNahar from "../../../images/Photos/Person_image.jpg";
import BadhonChakma from "../../../images/Photos/Person_image.jpg";
import ShibaliSantiChakma from "../../../images/Photos/Shibali Shanti Chakmaa.jpg";
import PalashKusumChakma from "../../../images/Photos/Palash-kusum-chakma.jpg";
import NichiDebiChakma from "../../../images/Photos/Person_image.jpg";
import UjjolaChakma from "../../../images/Photos/Person_image.jpg";
import JugantarChakma from "../../../images/Photos/Jugantar Chakma.jpeg";
import blankImage from "../../../images/Photos/Person_image.jpg";
import "../../../style/about/generalCouncil.css";
import Zoom from "react-reveal/Zoom";
import TranslateButton from "../../TranslateButton/TranslateButton";
import {
  FacebookIcon,
  FacebookShareButton,
  TwitterShareButton,
  TwitterIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

const GeneralCouncil = () => {
  useEffect(() => {
    document.title = `Development Concern | General Council`;
  }, []);

  // const shareUrl = "https://developmentconcerncht.org/about/general-council";

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}

      <div className="general_council_section">
        <div className="header_image">
          <p>Home | About</p>
          <h2>General Council</h2>
        </div>

        {/* Header Background Part Start */}
        {/* <div className="header_background">
          <div className="container wrapper">
            <h2> General Council </h2>
            <div className="social_share_button">
              <FacebookShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share facebook"}
                hashtag={"#facebook"}
              >
                <FacebookIcon size={35} round={true} />
              </FacebookShareButton>
              <TwitterShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share twitter"}
                hashtag={"#twitter"}
              >
                <TwitterIcon size={35} round={true} />
              </TwitterShareButton>
              <LinkedinShareButton
                url={shareUrl}
                target={"_blank"}
                quote={"share linkedin"}
                hashtag={"#linkedin"}
              >
                <LinkedinIcon size={35} round={true} />
              </LinkedinShareButton>
            </div>
          </div>
        </div> */}
        {/* Header Background Part End */}

        <div className="container">
          <h1>Member Of General Council</h1>
          <p>
            All the general members of Development Concern constitutes the General Council who has right to change/make amendments, declare dysfunction or ‘moving forward’ of the organization. There are 21 enlisted and approved general members at this moment. The zeal to work for the development of the community and having the good track record of professional history are the prerequisites of an individual for becoming a member of General Council. To become a member, one must have a recommendation from one of its existing members and approval of the Executive Body, which is then solemnized in the General Meeting.
          </p>

          {/* Another Image */}
          <div className="content_wrapper">
            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={RitaChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Rita Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={MoitriChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Moitri Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={SuchovanChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Sushovan Chakma</h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={blankImage} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Prabhat Kusum Chakma</h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={UdayonChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Udayan Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={blankImage} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Othelo Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={blankImage} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Sunetra Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={blankImage} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Nibedita Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={SabittriChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Sabittri Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={AratiChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Arati Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={blankImage} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Sujata Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={ArnobChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Arnob Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={MangalManiChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Mangal Moni Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={blankImage} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Ratna Surja Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={blankImage} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Bina Tara Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={ShibaliSantiChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Shibali Santi Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={PalashKusumChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Palash Kusum Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={blankImage} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Jonaki Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={blankImage} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Swapna Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={blankImage} alt="" />
                <div className="title_wrapper">
                  <h4>Ms. Madhumita Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>

            <Zoom duration={3000}>
              <div className="single_content_wrapper">
                <img src={JugantarChakma} alt="" />
                <div className="title_wrapper">
                  <h4>Mr. Jugantar Chakma </h4>
                  <p>Member</p>
                </div>
              </div>
            </Zoom>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default GeneralCouncil;
